import Vue from 'vue'
import { DownloadGenericTableAsXlsx } from '@/api/comparables'

export default Vue.extend({
  methods: {
    downloadGenericTable(tableClass) {
      var tableAsArray = []
      var tableDOM = document.querySelector('.' + tableClass)
      var childElements = tableDOM.childNodes
      var rowSpanControl = {}

      for (var i = 0; i < childElements.length; i++) {
        if (childElements[i].localName === 'thead' || childElements[i].localName === 'tbody' || childElements[i].localName === 'tfooter') {
          var tableSection = childElements[i].childNodes
          for (var j = 0; j < tableSection.length; j++) {
            tableAsArray.push(iterateRow(tableSection[j]))
          }
        } else {
          tableAsArray.push(iterateRow(childElements[i]))
        }
      }

      function iterateRow(rowNode) {
        var arrayToAdd = []
        var colsInRow = rowNode.childNodes

        for (var k = 0; k < colsInRow.length; k++) {
          if (!!rowSpanControl[k] && rowSpanControl[k] > 1) {
            arrayToAdd.push('')
            rowSpanControl[k] = rowSpanControl[k] - 1
          }
          if (colsInRow[k].rowSpan > 1) {
            rowSpanControl[k] = colsInRow[k].rowSpan
          }
          for (var y = 0; y < colsInRow[k].colSpan; y++) {
            arrayToAdd.push(y === 0 ? colsInRow[k].innerText : '')
          }
        }
        return arrayToAdd
      }

      DownloadGenericTableAsXlsx(tableAsArray)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/octet-stream' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'TableExport.xlsx'
          link.click()
        })
    },
    downloadDataSection(dataClass) {
      var tableAsArray = []
      var tableDOM = document.querySelector('.' + dataClass)
      var childElements = tableDOM.childNodes

      for (var i = 0; i < childElements.length; i++) {
        var categoryChilds = childElements[i].childNodes
        for (var j = 0; j < categoryChilds.length; j++) {
          if (categoryChilds[j].classList.contains('brains-data-list--headers-container')) {
            tableAsArray.push(iterateTitle(categoryChilds[j]))
          } else if (categoryChilds[j].classList.contains('brains-data-list--title')) {
            tableAsArray.push([categoryChilds[j].innerText, ''])
          } else {
            var rowsInContent = categoryChilds[j].childNodes
            for (var k = 0; k < rowsInContent.length; k++) {
              tableAsArray.push(iterateContent(rowsInContent[k]))
            }
          }
        }
        tableAsArray.push([])
      }

      function iterateTitle(rowNode) {
        var arrayToAdd = []
        var colsInRow = rowNode.childNodes

        for (var k = 0; k < colsInRow.length; k++) {
          arrayToAdd.push(colsInRow[k].innerText)
        }
        return arrayToAdd
      }

      function iterateContent(rowNode) {
        var arrayToAdd = []
        var colInRow = rowNode.childNodes

        for (var y = 0; y < colInRow.length; y++) {
          arrayToAdd.push(colInRow[y].querySelector('.brains-data-list-export-cell').innerText)
        }
        return arrayToAdd
      }

      DownloadGenericTableAsXlsx(tableAsArray)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/octet-stream' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'DataExport.xlsx'
          link.click()
        })
    }
  }
})
